import { UserLoginInfoApiPayload } from "Interface/user";
import BaseApiService from "./baseService";

class UserService extends BaseApiService {
  constructor() {
    super("users");
  }

  loginWithMs(param: UserLoginInfoApiPayload, headers = {}) {
    return this.post("login", param, false, undefined, headers);
  }

  login(param: { email: string; password: string }) {
    return this.post("login", param);
  }

  currentUser(param: object) {
    return this.get("getCurrentUser", param);
  }

  refreshToken(param: object) {
    return this.post("refresh-token", param);
  }

  // logout
  logout(param: object) {
    return this.post("logout", param);
  }
}

const userServiceObj = new UserService();
export default userServiceObj;
